exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".employee-form .employee-form__row {\n  display: flex;\n  justify-content: space-between;\n}\n\n.employee-form .employee-form__row>.input {\n  width: calc(50% - 0.9rem);\n}\n\n.employee-form .employee-form__section {\n  padding: 4rem 0;\n  max-width: 49rem;\n  margin: 0 auto;\n}\n\n.employee-form .employee-form__section:first-child {\n  padding-top: 0;\n}\n\n.employee-form h3 {\n  color: #839AA7;\n  text-align: center;\n}\n\n.employee-form .employee-form__employer-contribution {\n  padding-top: 3rem;\n}\n\n", ""]);

// exports
